import * as types from 'modules/devices/actionTypes';
import type { SendByEmailAction } from 'modules/devices/types';
import { createReducer } from 'utils/ReduxUtils';

const initialState: string | null = null;

const setEmail = (_: string | null, { payload }: SendByEmailAction) => payload?.request?.data?.email ?? null;

const resetState = () => null;

export default createReducer<string | null>(initialState, {
  [types.SEND_BY_EMAIL]: setEmail,
  [types.SEND_BY_EMAIL_FAILURE]: resetState,
  [types.OPEN_CREATE_DEVICE_MODAL]: resetState,
});
